import { Stack, TextProps } from "@chakra-ui/react";

import { MODAL_PADDING_X } from "./modalConstants";
import StatHeading from "./StatHeading";
import StatText from "./StatText";

const BasicInfoStat = ({
  label,
  value,
  ...props
}: {
  label: string;
  value?: string;
} & TextProps) => (
  <Stack spacing={2}>
    <StatHeading borderBottomWidth="1px" pl={MODAL_PADDING_X} {...props}>
      {label}
    </StatHeading>
    <StatText
      pl={MODAL_PADDING_X}
      pb={MODAL_PADDING_X}
      noOfLines={3}
      {...props}
    >
      {value}
    </StatText>
  </Stack>
);
export default BasicInfoStat;
